(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initControls(scope) {
      var groups = scope.querySelectorAll('.hello-carousel-controls');
      groups.forEach(function (controls) {
        if (controls.dataset.helloBound) return;
        var section = controls.closest('.section-resource-list');
        if (!section) return;
        var scroller = section.querySelector('slideshow-slides');
        if (!scroller) return;
        controls.dataset.helloBound = '1';

        var fill = controls.querySelector('.hello-carousel-progress__fill');
        var prev = controls.querySelector('[data-dir="prev"]');
        var next = controls.querySelector('[data-dir="next"]');

        function update() {
          var max = scroller.scrollWidth - scroller.clientWidth;
          var ratio = max > 4 ? scroller.scrollLeft / max : 1;
          ratio = Math.min(1, Math.max(0.12, ratio));
          if (fill) fill.style.transform = 'scaleX(' + ratio + ')';
          if (prev) prev.disabled = scroller.scrollLeft <= 2;
          if (next) next.disabled = max <= 4 || scroller.scrollLeft >= max - 2;
        }

        function step(dir) {
          scroller.scrollBy({ left: dir * scroller.clientWidth * 0.85, behavior: 'smooth' });
        }

        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });
        scroller.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        requestAnimationFrame(update);
      });
    }

    function boot() { initControls(document); }

    if (document.readyState !== 'loading') {
      boot();
    } else {
      document.addEventListener('DOMContentLoaded', boot);
    }
    document.addEventListener('shopify:section:load', function (e) { initControls(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
